<template>
  <ul class="eCEquipmentCom">
    <li v-for="(v, i) in defaultTypeList" :key="v.title">
      <div class="titleBox">
        <h6>{{ v.name }}</h6>
        <!-- <p>额定功率:2.3kw</p>
        <p>实时功率:1.3kw</p> -->
      </div>
      <div class="contentBox">
        <div class="generalControl">
          <p>
            {{ typeMenuData.treeActive.name }}总开关
            <span style="color: #53d6d5; font-weight: bold">{{
              v.openSize ?? 0
            }}</span
            >/{{ v.count ?? 0 }}
          </p>
          <div>
            <el-button
              size="mini"
              :disabled="!v.controlled"
              @click="
                changeSwitch(
                  v.name,
                  typeMenuData.treeActive.id,
                  typeMenuData.treeActive.name,
                  'OFF'
                )
              "
              >全关</el-button
            >
            <el-button
              size="mini"
              type="primary"
              :disabled="!v.controlled"
              @click="
                changeSwitch(
                  v.name,
                  typeMenuData.treeActive.id,
                  typeMenuData.treeActive.name,
                  'ON'
                )
              "
              >全开</el-button
            >
          </div>
        </div>
        <div class="controlBox">
          <div class="assetControlWrap" v-if="v.list?.length">
            <!-- 空调面板 -->
            <template
              v-if="
                (v.name == '分体式空调' || v.name == '风机盘管') &&
                !typeMenuData.treeActive.children?.length
              "
            >
              <AirConditioningCom
                :key="i"
                :dataList="v.list"
                @changeState="changeState"
              />
            </template>

            <!-- 照明及空调资产的控制 -->
            <template v-else>
              <div class="rowWrap" v-for="(item, index) in v.list" :key="index">
                <div class="textWrap">
                  <!-- 空调及照明 -->
                  <template v-if="v.defAttribute">
                    <el-tooltip
                      class="item"
                      effect="dark"
                      :content="item.name"
                      placement="top-start"
                      :disabled="
                        v.entityType === 'ASSET'
                          ? item.name?.length < 6
                          : item.name?.length < 11
                      "
                    >
                      <p
                        :class="
                          item.entityType == 'ASSET' ? 'defatTxt' : 'switchTxt'
                        "
                      >
                        {{ item.name }}
                        <!-- <span style="color: #53d6d5; font-weight: bold">{{
                          item.openSize
                        }}</span
                        >/{{ item.allSize }} -->
                      </p>
                    </el-tooltip>

                    <span>
                      <template v-if="item.entityType == 'ASSET'">
                        <el-button
                          type="text"
                          :disabled="!v.controlled"
                          @click="
                            changeSwitch(
                              v.name,
                              item.entityId,
                              item.name,
                              'OFF'
                            )
                          "
                          >全关</el-button
                        >
                        <el-button
                          type="text"
                          :disabled="!v.controlled"
                          @click="
                            changeSwitch(v.name, item.entityId, item.name, 'ON')
                          "
                          >全开</el-button
                        >
                      </template>
                      <template v-else>
                        <el-switch
                          :disabled="!v.controlled"
                          :value="item.isOpen"
                          @change="
                            changeState({
                              type: v.name,
                              entityId: item.entityId,
                              isOpen: item.isOpen ? 'OFF' : 'ON',
                              key: 'RunSign',
                            })
                          "
                        >
                        </el-switch>
                      </template>
                    </span>
                  </template>

                  <!-- 其余自定义用能设备 -->
                  <template v-else>
                    <el-tooltip
                      class="item"
                      effect="dark"
                      :content="item.deviceName"
                      placement="top-start"
                      :disabled="item.deviceName?.length < 11"
                    >
                      <p class="switchTxt">
                        {{ item.deviceName }}
                      </p>
                    </el-tooltip>
                    <span>
                      <el-switch v-model="item.runSign" disabled> </el-switch>
                    </span>
                  </template>
                </div>
              </div>
            </template>
          </div>
        </div>
      </div>
    </li>
  </ul>
</template>

<script>
import api from "@/api";
import { judgeAuthority } from "@/assets/js/utils";
import AirConditioningCom from "./AirConditioningCom";
export default {
  props: {
    typeMenuData: {
      type: Object,
      default: () => {},
    },
  },
  components: { AirConditioningCom },
  data() {
    return {
      defaultTypeList: [],
    };
  },
  watch: {
    typeMenuData: {
      handler() {
        this.$store.commit("SET_LOADING", true);
        this.$nextTick(() => {
          this.handlerDataList();
        });
      },
      deep: true,
      immediate: true,
    },
  },
  methods: {
    changeSwitch(type, id, name, status) {
      this.$confirm(
        `该操作将${
          status == "ON" ? "开启" : "关闭"
        }${name}内所有${type}，请确认是否执行此操作？`,
        "提示",
        {
          confirmButtonText: "执行",
          cancelButtonText: "取消",
          type: "warning",
        }
      )
        .then(() => {
          this.changeState({
            entityId: id,
            isOpen: status,
            type: type,
            key: "RunSign",
          });
        })
        .catch(() => {});
    },
    handlerDataList() {
      this.defaultTypeList = this.typeMenuData.typeList ?? [];
      Promise.all(
        this.defaultTypeList.map((v) => this.getDetailsList(v.name))
      ).then((res) => {
        res.map((v, i) => {
          this.defaultTypeList[i].list = v;
          this.defaultTypeList[i].defAttribute = true;
        });
        this.defaultTypeList.map((v) => {
          v.controlled = judgeAuthority(
            v.name === "照明设备"
              ? "zixitong:zhaoming:console:edit"
              : "zixitong:kongtiao:controls:edit"
          );
        });
        this.getCustomEnergyCount();
      });
    },
    async getDetailsList(type) {
      let tableList = [];
      let res = await api.subsystemAllDetailsList({
        assetId: this.typeMenuData.treeActive.id,
        modular: "开关",
        type: type,
        projectId: JSON.parse(window.sessionStorage.getItem("userInfo"))
          .projects[0].projectId,
        label: "区域位置",
        pageSize: 10000,
        page: 0,
      });
      if (res?.data.code == 200) {
        tableList = res.data.data.data;
        if (
          type !== "照明设备" &&
          !this.typeMenuData.treeActive.children?.length
        ) {
          tableList.map((v) => {
            v.SetTemperature = v.SetTemperature
              ? parseInt(v.SetTemperature)
              : 16;
            v.SetAirVolume = v.SetAirVolume ? parseInt(v.SetAirVolume) : 10;
            v.temp = v.SetTemperature;
            v.deviceType = type;
          });
        }
      }
      return tableList;
    },
    async getCustomEnergyCount() {
      let res = await api.BMSGetCustomEnergyCount({
        assetId: this.typeMenuData.treeActive.id,
      });
      if (res && res.data.code == 200) {
        this.$store.commit("SET_LOADING", false);
        let arr = res.data.data;
        arr.map((v) => {
          v.controlled = false;
          v.defAttribute = false;
        });
        this.defaultTypeList = this.defaultTypeList.concat(arr);

        this.$forceUpdate();
      }
    },

    async changeState(data) {
      this.$store.commit("SET_LOADING", true);
      let params = {
        projectId: JSON.parse(window.sessionStorage.getItem("userInfo"))
          .projects[0].projectId,
        entityId: data.entityId,
        modular: "开关",
        type: data.type,
        controlType: data.isOpen,
        key: data.key,
      };
      let obj = Object.assign({}, params, { value: data.value });
      let res = await api.subsystemControlSwitch(
        data.key == "RunSign" ? params : obj
      );
      if (res && res.data.code == 200) {
        setTimeout(() => {
          this.$message.success("操作成功");
          this.handlerDataList();
          this.$store.commit("SET_LOADING", false);
        }, 1000);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.eCEquipmentCom {
  width: 100%;
  height: 100%;
  overflow: auto;
  .el-button--text {
    padding: 0;
  }
  li {
    display: inline-block;
    width: 43%;
    height: 280px;
    margin: 0 15px 10px 0;
    padding: 20px 20px 10px 20px;
    background: #fff;
    border-radius: 6px;
    .titleBox {
      @include setFlexStart;
      p {
        margin: 0 10px;
      }
    }
    .contentBox {
      width: 100%;
      height: 88%;
      margin-top: 12px;
      border-top: 1px solid #e9e9e9;
      .generalControl {
        width: 100%;
        height: 45px;
        @include setFlexBetween;
      }
      .controlBox {
        width: 100%;
        height: calc(100% - 45px);
        .assetControlWrap {
          width: 100%;
          height: 100%;
          overflow: auto;
          .rowWrap {
            width: calc(50% - 10px);
            height: 38px;
            display: inline-block;
            background: #fafafa;
            border-radius: 2px;
            margin: 0 10px 10px 0;
            .textWrap {
              height: 100%;
              @include setFlexBetween;
              padding: 0 10px;
              p {
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
              }
              .defatTxt {
                width: 55%;
              }
              .switchTxt {
                width: 73%;
              }
            }
          }
          .panelContentWrap {
            width: 100%;
            height: 100%;
            @include setFlexBetween;
            .leftMenu {
              width: 43%;
              height: 100%;
              overflow: auto;
              .txtLi {
                height: 38px;
                background: #fafafa;
                line-height: 38px;
                border-radius: 2px;
                margin-bottom: 10px;
                cursor: pointer;
                p {
                  padding: 0 10px;
                  white-space: nowrap;
                  overflow: hidden;
                  text-overflow: ellipsis;
                }
                &:hover {
                  background: #e6f9f9;
                }
              }
              .activeTxtLi {
                background: $themeColor !important;
                color: #fff;
              }
            }
            .rightPanel {
              width: 55%;
              height: 100%;
            }
          }
        }
      }
    }
  }
}
</style>
